import { extractResourceTypeHandleFromRole } from '@toolproof-core/lib/_pure/workflow-extraction';
import type {
    MutableWorkflowStateEntry,
} from '@toolproof-core/lib/_contract/workflow-overlay';

import { mergeWorkflowStateEntries } from '@/workflow-builder/_pure/model/machineWorkflow';
import type { CosmosDataModel } from '@/workflow/_contract/cosmosData';
import type { RuntimeState } from '@/workflow-builder/_contract/runtime';
import type { SelectedBindingTarget } from '@/workflow-builder/_contract/selection';

export function selectBindingTargetFromSelection(args: {
    runtimeState: RuntimeState;
    cosmosData: CosmosDataModel;
}): SelectedBindingTarget | null {
    const selectedRoleName = args.runtimeState.selectionState.selectedInputRoleName;
    const selectedToolStep = args.runtimeState.selectionState.selectedToolStep;
    if (!selectedRoleName || !selectedToolStep) return null;

    const tool = args.cosmosData.toolMap.get(selectedToolStep.toolHandle);
    if (!tool) {
        return {
            roleName: selectedRoleName,
            resourceTypeHandle: null,
        };
    }

    const role = tool.roleSpec.inputRoleByName[selectedRoleName];
    const resourceTypeHandle = role
        ? extractResourceTypeHandleFromRole(role as Parameters<typeof extractResourceTypeHandleFromRole>[0])
        : null;

    return {
        roleName: selectedRoleName,
        resourceTypeHandle,
    };
}

export function deriveSelectedWorkflowStateEntry(runtimeState: RuntimeState): MutableWorkflowStateEntry | null {
    const selectedRoleName = runtimeState.selectionState.selectedInputRoleName;
    const selectedToolStep = runtimeState.selectionState.selectedToolStep;
    if (!selectedRoleName || !selectedToolStep) {
        return null;
    }

    const mergedWorkflowState = mergeWorkflowStateEntries(
        runtimeState.mutableWorkflow.workflowState,
        runtimeState.draft?.workflowState ?? {},
    );

    return mergedWorkflowState[selectedToolStep.stepKey]?.[selectedRoleName] ?? null;
}
